import React, { Fragment, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// CSS Modules, react-datepicker-cssmodules.css//
import 'react-datepicker/dist/react-datepicker-cssmodules.css'

function MonthYearDatePicker(props) {
    const [selectedDate, handleDateChange] = useState(props.value)

    return (
        <Fragment>
            <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                wrapperClassName="date-picker-wrapper"
                autoComplete="off"
                {...props}
            />
        </Fragment>
    )
}

export default MonthYearDatePicker
